import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type TrackCustomFieldsActionParams } from '../types';

export const useTrackClickedEditCustomField = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedEditCustomField = useCallback(
    (params: TrackCustomFieldsActionParams) => {
      track(`Clicked Edit custom field`, params);
    },
    [track],
  );

  return { trackClickedEditCustomField };
};
